import React from 'react';
import { Image, Typography } from 'antd';
import { ECommonEntityStatus } from 'entities/Bitecoin/Bitecoin.models';
import { getCommonEntityStatusText } from 'entities/Bitecoin/Bitecoin.helper';

export interface IMenuItemCollection extends Components.Schemas.MenuItemCollectionDto {}
export interface IMenuItemCollectionFilter extends Paths.MenuItemControllerGetList.QueryParameters {}
export interface IMenuItemModel extends Components.Schemas.MenuItemDto {
  // FE-derived label for the items table — not part of the API DTO.
  displayCategoryName?: string;
}
export interface IMenuItemCreateData extends Components.Schemas.MenuItemCreateDto {}
export interface IMenuItemUpdateData extends Components.Schemas.MenuItemUpdateDto {
  // `id`/`category` are not on MenuItemUpdateDto (id comes from the path, category is immutable).
  id: string;
  category: string;
}
export interface IMenuItemsNotOnMenuParams extends Paths.MenuItemControllerIntersection.QueryParameters {}

export enum EMenuItemSuccessMessage {
  Delete = 'Item has been successfully deleted',
  Create = 'Item has been successfully created',
  Edit = 'Item has been successfully edited',
}

export enum EMenuItemProductType {
  SandwichOnly = "sandwichOnly",
  Combo = "combo",
  Bundle = "bundle",
  Other = "other",
}

export enum EMenuItemProductTypeText {
  SandwichOnly = "Sandwich only",
  Combo = "Combo",
  Bundle = "Bundle",
  Other = "Other",
}

export enum EMenuItemDrinkOptions {
  Hot = "hot",
  Cold = "cold",
}

export enum EMenuItemDrinkOptionsText {
  Hot = "Hot drinks",
  Cold = "Cold drinks",
}

export const menuItemTableConfig = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    render: (item: string) => (
      <Typography.Paragraph ellipsis={{ rows: 3 }} title={item}>
        {item}
      </Typography.Paragraph>
    ),
  },
  {
    title: 'Permanent Category',
    dataIndex: 'categoryName',
    key: 'categoryName',
    ellipsis: true,
  },
  {
    title: 'Display Category',
    dataIndex: 'displayCategoryName',
    key: 'displayCategoryName',
    ellipsis: true,
  },
  {
    title: 'Image',
    dataIndex: 'image',
    key: 'image',
    ellipsis: true,
    width: '120px',
    render: (imageId: string) => (imageId ? <Image src={`/api/images/${imageId}`} /> : null),
  },
  {
    title: 'Description',
    dataIndex: 'description',
    key: 'description',
    render: (item: string) =>
      item ? (
        <Typography.Paragraph ellipsis={{ rows: 3 }} title={item}>
          {item}
        </Typography.Paragraph>
      ) : null,
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    render: (value: string) => (
      <Typography.Paragraph title={value}>
        {' '}
        {getCommonEntityStatusText(value as ECommonEntityStatus)}{' '}
      </Typography.Paragraph>
    ),
  },
];
